import PropTypes from "prop-types";
// @mui
import {
  Box,
  Link,
  Stack,
  Typography,
  Breadcrumbs,
  Button,
} from "@mui/material";
//
import LinkItem from "./LinkItem";
import { useLocales } from "src/locales";

// ----------------------------------------------------------------------

CustomBreadcrumbs.propTypes = {
  sx: PropTypes.object,
  action: PropTypes.node,
  links: PropTypes.array,
  heading: PropTypes.string,
  headingActions: PropTypes.node,
  moreLink: PropTypes.array,
  activeLast: PropTypes.bool,
};

export default function CustomBreadcrumbs({
  links,
  action,
  heading,
  headingActions,
  moreLink,
  activeLast,
  sx,
  ...other
}) {
  const { translate } = useLocales();
  const lastLink = links[links.length - 1]?.name ?? "";

  return (
    <Box sx={{ mb: 5, ...sx }}>
      <Stack direction="row" alignItems="center">
        <Box sx={{ flexGrow: 1 }}>
          {/* HEADING */}
          {heading && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                columnGap: "1rem",
              }}
            >
              {headingActions && headingActions}
              <Typography variant="h4" gutterBottom>
                {heading}
              </Typography>
            </Box>
          )}

          {/* BREADCRUMBS */}
          {!!links.length && (
            <Breadcrumbs separator={<Separator />} {...other}>
              {links.map((link) => (
                <LinkItem
                  key={link.name || ""}
                  link={link}
                  activeLast={activeLast}
                  disabled={link.name === lastLink}
                />
              ))}
            </Breadcrumbs>
          )}
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}> {action} </Box>}

        {other.shouldDisplay && other.adminDownloadFunction && (
          <Button
            variant="contained"
            onClick={other.adminDownloadFunction}
            sx={{ mt: 3 }}
          >
            {translate("companiesList.download")}
          </Button>
        )}
      </Stack>

      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{ mt: 2 }}>
          {moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: "table" }}
            >
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}

// ----------------------------------------------------------------------

function Separator() {
  return (
    <Box
      component="span"
      sx={{
        width: 4,
        height: 4,
        borderRadius: "50%",
        bgcolor: "text.disabled",
      }}
    />
  );
}
